import { produce } from "immer";
import { TablesState } from "../interfaces/tables-state";

export const setTableSearchHandler = function (state: TablesState,  tableId: string, searchValue: string | null) {

    const nextState = produce(state[tableId], draft => {
        if(draft.search == undefined)
            draft.search = { value: searchValue ?? ""};

        draft.search.value = searchValue ?? "";
    })

    return {
        ...state,
        [tableId]: {...nextState}
    }
}
